'use strict';
'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _create = require('babel-runtime/core-js/object/create');

var _create2 = _interopRequireDefault(_create);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _eventemitter = require('eventemitter3');

var _eventemitter2 = _interopRequireDefault(_eventemitter);

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _compareVersions = require('compare-versions');

var _compareVersions2 = _interopRequireDefault(_compareVersions);

var _Misc = require('@/helpers/Misc');

var Misc = _interopRequireWildcard(_Misc);

var _Logger = require('./Logger');

var _Logger2 = _interopRequireDefault(_Logger);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var singletonInstance = null;
var pluginsToInit = [];
var nextPluginId = 0;

var GlobalApi = function (_EventEmitter) {
    (0, _inherits3.default)(GlobalApi, _EventEmitter);

    function GlobalApi() {
        (0, _classCallCheck3.default)(this, GlobalApi);

        var _this = (0, _possibleConstructorReturn3.default)(this, (GlobalApi.__proto__ || (0, _getPrototypeOf2.default)(GlobalApi)).call(this));

        _this.version = __VERSION__;

        _this.Vue = _vue2.default;

        _this.state = null;

        _this.themes = null;
        _this.controlInputPlugins = [];
        _this.stateBrowserPlugins = [];
        _this.channelHeaderPlugins = [];
        _this.queryHeaderPlugins = [];
        _this.sideBarPlugins = [];
        _this.appSettingsPlugins = [];
        _this.serverViewPlugins = [];
        _this.aboutBufferPlugins = [];
        _this.tabs = (0, _create2.default)(null);
        _this.isReady = false;

        _this.exports = window._kiwi_exports || {};

        _this.on('init', function () {
            _this.isReady = true;
            _this.initPlugins();
        });
        return _this;
    }

    (0, _createClass3.default)(GlobalApi, [{
        key: 'versionMatches',
        value: function versionMatches(v) {
            return (0, _compareVersions2.default)(this.version, v) >= 0;
        }
    }, {
        key: 'plugin',
        value: function plugin(pluginName, fn) {
            var plugin = { name: pluginName, fn: fn };
            if (this.isReady) {
                this.initPlugin(plugin);
            } else {
                pluginsToInit.push(plugin);
            }
        }
    }, {
        key: 'initPlugins',
        value: function initPlugins() {
            var _this2 = this;

            pluginsToInit.forEach(function (plugin) {
                return _this2.initPlugin(plugin);
            });
            pluginsToInit = [];
        }
    }, {
        key: 'initPlugin',
        value: function initPlugin(plugin) {
            var pluginLogger = _Logger2.default.namespace('Plugin ' + plugin.name);
            try {
                plugin.fn(this, pluginLogger);
                this.state.$emit('plugin.loaded', { name: plugin.name });
            } catch (err) {
                pluginLogger.error(err.stack);
            }
        }
    }, {
        key: 'require',
        value: function require(modPath) {
            var path = modPath.replace(/\//g, '.');
            var mod = _lodash2.default.get(this.exports, path);
            if (typeof mod === 'undefined') {
                _Logger2.default.error('Module does not exist: ' + modPath);
            }

            return mod;
        }
    }, {
        key: 'setState',
        value: function setState(state) {
            var _this3 = this;

            this.state = state;

            var stateEmit = this.state.$emit;
            var thisEmit = this.emit;

            this.state.$emit = function () {
                for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                    args[_key] = arguments[_key];
                }

                try {
                    thisEmit.call.apply(thisEmit, [_this3, 'all', args[0]].concat((0, _toConsumableArray3.default)(args.slice(1))));
                    thisEmit.call.apply(thisEmit, [_this3].concat(args));
                } catch (err) {
                    _Logger2.default.error(err.stack);
                }

                return stateEmit.call.apply(stateEmit, [_this3.state].concat(args));
            };

            this.emit = function () {
                for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                    args[_key2] = arguments[_key2];
                }

                stateEmit.call.apply(stateEmit, [_this3.state].concat(args));
                thisEmit.call.apply(thisEmit, [_this3].concat(args));
            };
        }
    }, {
        key: 'setThemeManager',
        value: function setThemeManager(themeManager) {
            this.themes = themeManager;
        }
    }, {
        key: 'logLevel',
        value: function logLevel(newLevel) {
            _Logger2.default.setLevel(newLevel);
        }
    }, {
        key: 'addUi',
        value: function addUi(type, element) {
            var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            var plugin = {
                el: element,
                id: nextPluginId++,
                args: args
            };

            switch (type) {
                case 'input':
                    this.controlInputPlugins.push(plugin);
                    break;
                case 'browser':
                    this.stateBrowserPlugins.push(plugin);
                    break;
                case 'header_channel':
                    this.channelHeaderPlugins.push(plugin);
                    break;
                case 'header_query':
                    this.queryHeaderPlugins.push(plugin);
                    break;
                case 'about_buffer':
                    this.aboutBufferPlugins.push(plugin);
                    break;
                default:
                    break;
            }
        }
    }, {
        key: 'addTab',
        value: function addTab(type, title, component, props) {
            var plugin = {
                id: nextPluginId++,
                title: title,
                component: component,
                props: props
            };

            switch (type) {
                case 'channel':
                    this.sideBarPlugins.push(plugin);
                    break;
                case 'settings':
                    this.appSettingsPlugins.push(plugin);
                    break;
                case 'server':
                    this.serverViewPlugins.push(plugin);
                    break;
                default:
                    break;
            }
        }
    }, {
        key: 'addView',
        value: function addView(name, component, props) {
            this.tabs[name] = {
                id: nextPluginId++,
                component: _vue2.default.extend(component),
                props: props || {}
            };
        }
    }, {
        key: 'showView',
        value: function showView(name) {
            var tab = this.tabs[name];
            if (tab) {
                this.state.$emit('active.component', tab.component, tab.props);
            } else {
                this.state.$emit('active.component', null);
            }
        }
    }, {
        key: 'showInSidebar',
        value: function showInSidebar(component) {
            this.state.$emit('sidebar.component', component);
        }
    }, {
        key: 'addStartup',
        value: function addStartup(name, ctor) {
            var startups = this.state.getStartups();
            startups[name] = ctor;
        }
    }, {
        key: 'replaceModule',
        value: function replaceModule(dest, source) {
            var mod = this.require(dest);
            if (!mod) {
                throw new Error('The module ' + dest + ' does not exist');
            }

            Misc.replaceObjectProps(mod, source);
        }
    }], [{
        key: 'singleton',
        value: function singleton() {
            singletonInstance = singletonInstance || new GlobalApi();
            return singletonInstance;
        }
    }]);
    return GlobalApi;
}(_eventemitter2.default);

exports.default = GlobalApi;
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["GlobalApi"]
window._kiwi_exports.libs.GlobalApi = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./src/libs/GlobalApi.js
// module id = Uvbb
// module chunks = 1